import classNames from 'classnames';
import { AVERAGE_UNITS } from 'infrastructure/consts/average-units';
import { useTranslation } from 'react-i18next';
import RectangleArrowIcon from 'components/atoms/icons/rectangleArrowIcon';

import s from './styles.module.scss';

import type { ThresholdType } from 'infrastructure/enums';
import type {
  IPatientSnapshotPercentage,
  TTrend,
} from 'infrastructure/interfaces';
import type { FC } from 'react';

interface ReadingCardProps {
  type: ThresholdType;
  values: {
    total: number;
    highest: number;
    lowest: number;
    average: number;
  };
  trend: TTrend;
  statusPercentages: IPatientSnapshotPercentage;
}

const ReadingCard: FC<ReadingCardProps> = ({
  type,
  values: { total, highest, lowest, average },
  statusPercentages: { critical, risk, normal },
  trend,
}) => {
  const { t } = useTranslation();
  const trendClassName = !trend
    ? s.hide
    : Object.entries(trend).map(([key, val]) => s[`${key}-${val}`])[0];

  return (
    <div className={s['reading-item-wrapper']}>
      <div className={s['reading-numbers']}>
        <p className={s.type}>
          <RectangleArrowIcon
            width={16}
            height={16}
            className={classNames(s.arrow, trendClassName)}
          />
          {type}
        </p>
        <div className={s.percentage}>
          <p className={s.red}>{critical}%</p>
          <p className={s.yellow}>{risk}%</p>
          <p className={s.green}>{normal}%</p>
        </div>
      </div>
      <div className={s.body}>
        <div className={s.counts}>
          <p className={s.count}>
            {t('labels.total')}:<span>{total}</span>
          </p>
          <p className={s.count}>
            {t('patientSnapshot.average')}:
            <span>
              {average}
              <i>{AVERAGE_UNITS[type]}</i>
            </span>
          </p>
          <p className={s.count}>
            {t('patientSnapshot.highest')}:
            <span>
              {highest}
              <i>{AVERAGE_UNITS[type]}</i>
            </span>
          </p>
          <p className={s.count}>
            {t('patientSnapshot.lowest')}:
            <span>
              {lowest}
              <i>{AVERAGE_UNITS[type]}</i>
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};
export default ReadingCard;
